import React, { useState, useEffect } from 'react';
import "../Home/table.css";
import ApiService from '../../../EpicGame/services/apiService';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';

const AddDebit = () => {
    const apiService = new ApiService();
    const location = useLocation();
    const navigate = useNavigate();
    const dabitDetails = location.state;

    const [loader, setLoader] = useState(false);
    const [userData, setUserData] = useState();
    const [walletForm, setWalletForm] = useState({
        cryptocurrency: 'Deposit',
        amount: ''
    });

    useEffect(() => {
        fetchuser();
    }, []);
    const fetchuser = async () => {
        try {
            const params = new URLSearchParams();
            params.append('username', dabitDetails?.email || "");
            const response = await apiService.getApiParamater('GET_GAME_USER', `?${params.toString()}`);
            const selectedUser = response?.data.find(x => x.email === dabitDetails?.email);
            setUserData(selectedUser);
        } catch (error) {
            console.error("Error fetching Currency data:", error);
        }
    };
    const handleAddDebit = async () => {
        if (!walletForm.amount || parseFloat(walletForm.amount) <= 0) {
            toast.warning("Please enter a valid amount");
            return;
        }

        setLoader(true);

        const payload = {
            userId: dabitDetails?.id,
            amount: parseFloat(walletForm.amount),
            isAddition: walletForm.cryptocurrency === 'Deposit',
            gameLevel: userData?.playedGames + 1
        };
        try {
            const response = await apiService.post('POST_DEPOSIT', payload);
            if (response?.status === 200) {
                toast.success("Transaction successful!");
                navigate(-1); // Go back to previous page
            } else {
                toast.error("Transaction failed!");
            }
        } catch (error) {
            console.error("Error in Deposit:", error);
            toast.error("Something went wrong.");
        } finally {
            setLoader(false);
        }
    };

    const handledebitChange = (e) => {
        const { name, value } = e.target;
        setWalletForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className='p-lg-5 m-5'>
            <div className='p-lg-5 m-5'>
                <h3 className="mb-4">Add Debit / Deposit</h3>
                <div className='center'>
                    <div className="blackBox p-4 shadow-sm w-50" style={{ background: "#fff" }}>
                        <div className="form-group mb-3">
                            <label className="form-label d-flex text-start">User Email</label>
                            <input
                                type="text"
                                className="form-control"
                                disabled
                                value={dabitDetails?.email || ''}
                            />
                        </div>

                        <div className="form-group mb-3">
                            <label className="form-label d-flex text-start">Type</label>
                            <div className="d-flex gap-4">
                                {['Deposit', 'WithDraw'].map((coin) => (
                                    <div key={coin} className="form-check">
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="cryptocurrency"
                                            value={coin}
                                            id={coin}
                                            checked={walletForm.cryptocurrency === coin}
                                            onChange={handledebitChange}
                                        />
                                        <label className="form-check-label" htmlFor={coin}>
                                            {coin}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="form-group mb-4">
                            <label className="form-label d-flex text-start">Amount</label>
                            <input
                                type="number"
                                className="form-control"
                                name="amount"
                                value={walletForm.amount}
                                onChange={handledebitChange}
                                placeholder="Enter amount"
                                min="0"
                            />
                        </div>

                        <div className="center">
                            <Button
                                variant="primary" className='center'
                                onClick={handleAddDebit}
                                disabled={loader}
                            >
                                {loader ? "Saving..." : "Save"}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddDebit;
